import axios from 'axios'

// 创建axios实例
const service = axios.create({
  baseURL: 'http://8.130.14.101:9060/guoKai',
  timeout: 100000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从localStorage获取token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['X-Token'] = token
    }
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res && res.msg && res.msg.includes('拒绝授权')) {
      res.msg = '账号已下线，请重新登录'
    }
    return res
  },
  error => {
    console.log('err' + error)
    return Promise.reject(error)
  }
)

// 封装GET请求
export function getAliAction(url, params) {
  return service({
    url: url,
    method: 'get',
    responseType: 'blob',
    timeout: 6000000,
    params
  })
}

// 封装POST请求
export function postAliAction(url, data) {
  return service({
    url: url,
    method: 'post',
    data
  })
}

export default service
